import React, { useCallback, useEffect, useState } from "react";
import { Form, Input, Button, Col, Tooltip, Select } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { putRequest, getRequest } from "../../api/http";
import UserIcon from "../../assets/images/user-icon.svg";
import leftArrow from "../../assets/images/LeftArrow.svg";
import { toast } from "react-toastify";
import uuid from "react-uuid";
import { useNavigate, useLocation } from "react-router-dom";
import userServiceApi from "../../api/userServiceApi";
import "./editPartner.scss";
import { inputFieldCharLimit } from '../../config/index'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const stripLeadingPlus = (value) => (value || "").replace(/^\++/, "");

const toApiMobileNumber = (value) => {
  const digits = stripLeadingPlus(value);
  return digits ? `+${digits}` : digits;
};

const EditPartner = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { state } = useLocation() || {};
  const [partner, setPartner] = useState(() => state?.selectedPartner || {});
  const [selectedPartnerType, setSelectedPartnerType] = useState();
  const [partnerType, setPartnerType] = useState([]);
  const [getFile, setFile] = useState();
  const [media, setmedia] = useState({});
  const [form] = Form.useForm();

  const [selectedSalesType, setSelectedSalesType] = useState(null);
  const [salesType, setSalesType] = useState([]);

  const getAllTypes = useCallback(async (type) => {
    try {
      const partnerID = state?.selectedPartner?.id;
      const api = type === "PARTNER_TYPE"
        ? userServiceApi.getAllActivePartnerTypes(partnerID)
        : userServiceApi.getAllActiveSalesTypes(partnerID);

      const response = await getRequest(api);

      if (response) {
        if (type === "PARTNER_TYPE") setPartnerType(response?.data ?? []);
        else if (type === "SALES_TYPE") setSalesType(response?.data ?? []);
      }
    } catch (error) {
      console.error(error);
    }
  }, [state?.selectedPartner?.id]);

  useEffect(() => {
    getAllTypes("PARTNER_TYPE");
    getAllTypes("SALES_TYPE");
    if (!state?.selectedPartner) return;
    setPartner(state.selectedPartner);
    form.setFieldsValue({
      countryName: state.selectedPartner.countryName ?? "",
    });
  }, [state?.selectedPartner, getAllTypes, form]);




  const changeHandler = (event) => {
    const fileTemp = event.target.files[0]
    if (!fileTemp?.type?.startsWith('image/')) {
      toast.error('Only image files are allowed')
      return
    }
    if (event.target.files && event.target.files[0].size >= 2e6) {
      toast.error("File size should not exceed 2MB");
    } else {
      let unique_ID = uuid();
      var file = event.target.files[0].name;
      var FT = event.target.files[0].type;
      // var fSize = event.target.files[0].size;
      //Get file name
      var fileArray = file.split(".");
      var fileExt = fileArray[fileArray.length - 1];
      //Get file type
      var fileName = file.split(".").slice(0, -1).join(".");
      var fileType = FT.substr(0, FT.lastIndexOf("/"));
      const items = {
        mediaType: fileType === "image" ? "IMAGE" : null,
        mediaProperty: {
          id: unique_ID,
          name: fileName,
          extension: fileExt,
        },
      };
      setmedia({ ...items });
      var image = event.target.files[0];
      var blob = image.slice(0, image.size);
      const newFile = new File([blob], `${unique_ID}_${fileName}.${fileExt}`, {
        type: `${image.type}`,
      });
      setFile(newFile);

      const fields = form.getFieldsValue(true);
      form.resetFields();
      form.setFieldsValue({ ...fields, media: newFile });
    }
  };

  const onFinish = async (values) => {
    let adr = values.address.replace(/(\r\n|\n|\r)/g, " ");
    setLoading(true);
    if (getFile) {
      try {
        let formData = new FormData();
        const modifiedData = {
          id: partner.id,
          website: values.website,
          // address: values.address,
          name: values.name,
          address: adr,
          siteName: values.siteName,
          membershipAdTitle: values.membershipAdTitle,
          description: values.description,
          twitterHandle: values.twitterHandle,
          media: media,
          mobileNumber: toApiMobileNumber(values.mobileNumber),
          // appName: values.appName,
          partnerTypeId: values.partnerTypeId,
          salesTypeId: values?.salesTypeId,
        };
        formData.append("file", getFile);

        const json = JSON.stringify(modifiedData);
        const blob = new Blob([json], {
          type: "application/json",
        });
        formData.append("partnerInput", blob);
        const response = await putRequest(
          userServiceApi.partnerDetails(),
          formData
        );

        if (response) {
          setLoading(false);
          toast.success("Partner Details Updated Successfuly");
          navigate("/admin");
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.error);
      }
    } else {
      try {
        let formData = new FormData();
        const modifiedData = {
          id: partner.id,
          name: values.name,
          address: adr,
          siteName: values.siteName,
          membershipAdTitle: values.membershipAdTitle,
          membershipAdDescription: values.membershipAdDescription,
          membershipLink: values.membershipLink,
          description: values.description,
          twitterHandle: values.twitterHandle,
          mobileNumber: toApiMobileNumber(values?.mobileNumber),
          // appName: values.appName,
          partnerTypeId: values.partnerTypeId,
          salesTypeId: values?.salesTypeId,
        };

        const json = JSON.stringify(modifiedData);
        const blob = new Blob([json], {
          type: "application/json",
        });
        formData.append("partnerInput", blob);

        const response = await putRequest(
          userServiceApi.partnerDetails(),
          formData
        );
        if (response) {
          setLoading(false);
          toast.success("Partner Details Updated Successfuly");
          navigate("/admin");
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.error);
      }
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <div>
      <div
        className="profile-card-container"
      >
        {Object.keys(partner).length > 0 ? (
          <div>
            <div
              className="heading-backBtn"
              onClick={() => navigate("/admin")}
            >
              <img
                style={{ marginRight: "8px" }}
                src={leftArrow}
                alt="leftarrow"
              />
              Edit Partner
            </div>


            <div className="multipalFormStyle">
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                initialValues={{
                  name: partner?.name,
                  email: partner?.email,
                  website: partner?.website,
                  media: partner?.media,
                  mediaLink: partner?.mediaLink,
                  address: partner?.address,
                  siteName: partner?.siteName,
                  description: partner?.description,
                  mobileNumber: stripLeadingPlus(partner?.mobileNumber),
                  countryName: partner?.countryName,
                  subdomain: partner?.subDomainName || '',
                  // appName: partner?.appName,
                  appLogo: partner?.appLogo,
                  partnerTypeId: partner?.partnerTypeId,
                  salesTypeId: partner?.salesTypeId,
                }}
              >
                <div className="multipalFormRow">
                  <div className="multipalFormCol">
                    <div className="formListRow">
                      <div className="formListCol">
                        <Form.Item
                          label="Partner Name"
                          labelCol={{ span: 5 }}
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "Partner name is required",
                            },
                          ]}
                        >
                          <Input placeholder="Partner Name" maxLength={inputFieldCharLimit} />
                        </Form.Item>

                        <Form.Item
                          labelCol={{ span: 5 }}
                          label="Email"
                          name="email"
                        >
                          <Input disabled placeholder="Email" />
                        </Form.Item>

                        <Form.Item
                          labelCol={{ span: 5 }}
                          label="Mobile Number"
                          name="mobileNumber"
                          rules={[
                            {
                              required: true,
                              message: "Please enter a mobile number",
                            },
                          ]}
                        >
                          <PhoneInput
                            country={"in"}
                            enableSearch
                            inputStyle={{
                              width: "100%",
                              height: "40px"
                            }}
                            onChange={(value) => {
                              form.setFieldsValue({
                                mobileNumber: value,
                              });
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          labelCol={{ span: 5 }}
                          label="Country"
                        >
                          <Input
                            disabled
                            value={partner?.countryName || state?.selectedPartner?.countryName || ""}
                            placeholder="Country"
                          />
                        </Form.Item>
                        <Form.Item
                          className="ptnrDtl"
                          labelCol={{ span: 5 }}
                          label="Address"
                          name="address"
                          rules={[
                            {
                              required: true,
                              message: "Address is required",
                            },
                          ]}
                        >
                          <Input.TextArea rows={5} placeholder="Address" />
                        </Form.Item>
                        <Form.Item
                          label="Site name"
                          labelCol={{ span: 5 }}
                          name="siteName"
                          rules={[
                            {
                              required: true,
                              message: "Site name is required",
                            },
                          ]}
                        >
                          <Input maxLength={25} showCount placeholder="Site name" />
                        </Form.Item>
                        <Form.Item
                          colon={false}
                          labelCol={{ span: 5 }}
                          label={
                            <div className="ant-form-item-label">
                              <label
                                htmlFor="media"
                                // className="ant-form-item-required"
                                title="Orgnanization logo"
                              >
                                Logo
                              </label>
                            </div>
                          }
                          name="mediaLink"
                          className="experienceImg"
                          rules={[
                            {
                              required: true,
                              message: "Logo is required",
                            },
                          ]}
                        >
                          {partner?.mediaLink ? (
                            getFile ? (
                              <div>
                                <img
                                  src={
                                    getFile ? URL.createObjectURL(getFile) : null
                                  }
                                  alt=""
                                  style={{
                                    maxHeight: "120px",
                                    width: "300px",
                                    border: "1px solid #A5A5A5",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    marginBottom: "-10px",
                                    marginRight: "10px",
                                  }}
                                />
                                <Tooltip
                                  title={"Upload image with size lesser than 2MB. Recommended image dimensions: 1280x720 pixels"}
                                >
                                  <label
                                    className="fileUploadBtn redBtn"
                                    style={{ padding: "8px" }}
                                  >
                                    {" "}
                                    Upload Image
                                    <input
                                      onChange={changeHandler}
                                      type="file"
                                      style={{ display: "none" }}
                                      maxLength={inputFieldCharLimit}
                                    />
                                  </label>
                                </Tooltip>
                              </div>
                            ) : (
                              <div>
                                <img
                                  src={partner?.mediaLink}
                                  alt=""
                                  style={{
                                    maxHeight: "120px",
                                    width: "300px",
                                    border: "1px solid #A5A5A5",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    marginBottom: "-10px",
                                    marginRight: "10px",
                                  }}
                                />
                                <label
                                  className="fileUploadBtn redBtn"
                                  style={{ padding: "8px" }}
                                >
                                  {" "}
                                  Upload Image
                                  <input
                                    onChange={changeHandler}
                                    type="file"
                                    style={{ display: "none" }}
                                    maxLength={inputFieldCharLimit}
                                  />
                                </label>
                                <Tooltip
                                  title={"Upload only .PNG, .JPG or .JPEG images and File size shouldn't exceed 2MB. Recommended image dimensions: 1280x720 pixels"}
                                >
                                  <QuestionCircleOutlined className="question-small" />
                                </Tooltip>
                              </div>
                            )
                          ) : (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <img
                                src={UserIcon}
                                alt=""
                                style={{ maxHeight: "80px", marginRight: "10px" }}
                              />
                              <Tooltip
                                title={"Upload image with size lesser than 2MB. Recommended image dimensions: 1280x720 pixels"}
                              >
                                <label
                                  className="fileUploadBtn redBtn"
                                  style={{ padding: "8px" }}
                                >
                                  {" "}
                                  Upload Image
                                  <input onChange={changeHandler} type="file" maxLength={inputFieldCharLimit} />
                                </label>
                              </Tooltip>
                            </div>
                          )}
                        </Form.Item>
                        <div className="d-flex subdomain">
                          <Col className="gutter-row helpOrg" span={24} style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                            <Form.Item
                              label={<span style={{ marginLeft: '11px' }}>Subdomain</span>}
                              labelCol={{ span: 5 }}
                              name="subdomain"
                            >
                              <Input disabled placeholder="Subdomain" maxLength={inputFieldCharLimit} />
                            </Form.Item>
                          </Col>
                          <Col className="gutter-row helpOrg" span={1}>
                            <Form.Item>
                              <div className="remove-btn">
                                <Tooltip
                                  title={"Please contact admin for any changes"}
                                >
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              </div>
                            </Form.Item>
                          </Col>
                        </div>

                        <Form.Item
                          labelCol={{ span: 5 }}
                          label={<span>Partner type</span>}
                          name="partnerTypeId"
                          rules={[
                            {
                              required: true,
                              message: "Partner Type is required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Partner Type"
                            value={selectedPartnerType}
                            onChange={(e) => setSelectedPartnerType(e)}
                          >
                            {partnerType?.map((partner, i) => (
                              <Select.Option key={i} value={partner.id}>
                                {partner.displayName}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          labelCol={{ span: 5 }}
                          label={<span>Sales type</span>}
                          name="salesTypeId"
                          rules={[
                            {
                              required: true,
                              message: "Sales Type is required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Sales Type"
                            value={selectedSalesType}
                            onChange={(e) => setSelectedSalesType(e)}
                          >
                            {salesType?.map((item, i) => (
                              <Select.Option key={i} value={item?.id}>
                                {item?.displayName}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="formListRow">
                      <div className="formListCol" style={{ textAlign: 'right' }}>
                        <Form.Item>
                          <Button className="sendBtn redBtn" htmlType="submit" loading={loading}>
                            Update
                          </Button>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default EditPartner;
